/* eslint-disable no-use-before-define */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useState } from 'react';

import { Row, Col, Space } from 'antd';
import PropTypes from 'prop-types';
import { UISearch } from '@components';
import Navigation from '../Navigation';
import UiLanguage from '../Language/language';
import Link from '../Link';
import s from './Header.css';
import ModalLogin from '../ModalLogin';
import logoUrl from '../../global/assets/logoYoloya.png';
import { MenuOutlined } from '@ant-design/icons';

export default function Header(props) {
  const [visibleLogin, setVisible] = useState(false);
  const [token, setToken] = useState(props.props.token);
  const [userData, setUserData] = useState(null);
  const [menuHeader, setMenuHeader] = useState(null);
  const language = props.props.language;
  const isMobile = props.props.isMobile

  useStyles(s);

  useEffect(() => {
    const userDatas = getCookie('userData');
    const userId = getCookie('UID');
    setToken(props.props.token);
    const uData = userDatas ? JSON.parse(userDatas) : {};
    uData.userId = userId;
    setUserData(uData);
  }, []);

  useEffect(() => {
    if (props.dataHeaderFooter) {
      const magisTemp = mappingHeadeSubMenu(
        'Magis!',
        props.dataHeaderFooter.magis,
      );
      const alumniTemp = mappingHeadeSubMenu(
        'Alumni',
        props.dataHeaderFooter.alumni,
      );
      const sekolahTemp = props.dataHeaderFooter.linkSekolah;
      const danaPembangunan = props.dataHeaderFooter.listMenuPengembangan
        ? props.dataHeaderFooter.listMenuPengembangan
        : null;
      const body = {
        magis: magisTemp,
        alumni: alumniTemp,
        sekolah: sekolahTemp,
        danaPembangunan: danaPembangunan,
      };
      setMenuHeader(body);
    }
  }, [props.dataHeaderFooter.magis]);

  const mappingHeadeSubMenu = (menu, submenuData) => {
    const dataTemp = submenuData || [];
    const subMenuTemp = [];
    const body = {
      menu,
      subMenu: [],
    };
    dataTemp.map(res => {
      subMenuTemp.push({
        name: res.label,
        path: res.url,
        isNewTab: true,
      });
    });
    body.subMenu = subMenuTemp;
    return body;
  };

  const onClickLogin = isLogin => {
    if (props.props.isMobile) {
      closeNav();
    }
    setVisible(isLogin);
  };

  const cancelLogin = () => {
    setVisible(false);
  };

  const getCookie = c_name => {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(`${c_name}=`);
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(';', c_start);
        if (c_end == -1) {
          c_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return '';
  };

  const handleMenu = () => {
    document.getElementById('sideBarNav').style.width =  isMobile ? '240px' : '200px';
    document.getElementById('sideBarNav').style.padding = '20px';
    document.getElementById('blakBackground').style.display = 'block';
    document.body.style.height = '100%';
    document.body.style.overflow = 'hidden';
  };
  const closeNav = () => {
    document.getElementById('sideBarNav').style.width = '0px';
    document.getElementById('sideBarNav').style.padding = '0px';
    document.getElementById('blakBackground').style.display = 'none';
    document.body.style.height = 'unset';
    document.body.style.overflow = 'auto';
  };
  const isTablet = props.props.isTablet;
  const itemColRight = isTablet ? 3 : 5;
  const itemColMid = isTablet ? 21 : 19;

  return (
    <>
      {props.props.isMobile ? (
        <div className={s.rootMobile}>
          <div className={s.stickyWrapperMobile}>
            <div className={s.containerMobile}>
              <Row justify="space-between">
                <Col
                  span={4}
                  style={{ textAlign: 'center', alignSelf: 'center' }}
                >
                  <MenuOutlined
                    onClick={() => handleMenu()}
                    style={{
                      fontSize: '25px',
                      color: 'white',
                    }}
                  />
                </Col>
                <Col span={20}>
                  <Link to="/">
                    <div
                      className={s.containerLogo}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <img
                        src={logoUrl}
                        alt="yayasan"
                        width="40px"
                        height="40px"
                      />
                      <div
                        className={s.titleHeader}
                        style={{ paddingLeft: 10 }}
                      >
                        {props.dataHeaderFooter.namaInstitusi ?  props.dataHeaderFooter.namaInstitusi.replace("\\n", '') : ''}
                      </div>
                    </div>
                  </Link>
                </Col>
              </Row>
            </div>
          </div>
          <div id="sideBarNav" className={s.sideBarNav}>
            <Space direction={'vertical'} size={isMobile ? 125 : 200}>
              <Row gutter={[24, 24]}>
                <Col span={24}>
                  <span className={s.closebtn} onClick={() => closeNav()}>
                    &times;
                  </span>
                </Col>
                <Col span={24} style={{ padding: 0, paddingTop: 12 }}>
                  <Navigation
                    language={props.props.language}
                    addMenu={menuHeader}
                    isMobile={props.props.isMobile}
                    closeNav={() => closeNav()}
                  />
                </Col>
              </Row>
              <Row />
              <Row gutter={[24, 24]} justify="space-between">
                <Col span={24}>
                  <ModalLogin
                    visible={visibleLogin}
                    handleLogin={isLogin => onClickLogin(isLogin)}
                    handleCancelLogin={() => cancelLogin()}
                    hiddenButton={false}
                    isTablet={props.props.isTablet}
                    isMobile={props.props.isMobile}
                    tokenUser={token}
                    language={language}
                  />
                </Col>
                <Col span={8}>
                  <a
                    href={`https://api.whatsapp.com/send?phone=62${props.dataHeaderFooter.headInfoWa}`}
                    target="_blank"
                  >
                    <img
                      alt="WhatsApp"
                      src="data:image/svg+xml;base64,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"
                    />
                  </a>
                </Col>
                <Col span={8}>
                  <a
                    href={`https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=${props.dataHeaderFooter.footInfoEmail}`}
                    target="_blank"
                  >
                    <img
                      alt="Mail"
                      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjE2NjU5IDAuMTY2NzQ4SDE0LjgzMzNDMTUuNzA0MSAwLjE2Njc0OCAxNi40MTY2IDAuODc5MjQ4IDE2LjQxNjYgMS43NTAwOFYxMS4yNTAxQzE2LjQxNjYgMTIuMTIwOSAxNS43MDQxIDEyLjgzMzQgMTQuODMzMyAxMi44MzM0SDIuMTY2NTlDMS4yOTU3NSAxMi44MzM0IDAuNTgzMjUyIDEyLjEyMDkgMC41ODMyNTIgMTEuMjUwMVYxLjc1MDA4QzAuNTgzMjUyIDAuODc5MjQ4IDEuMjk1NzUgMC4xNjY3NDggMi4xNjY1OSAwLjE2Njc0OFpNOS4zMzkwOSA2Ljc2OTI1TDE0LjUxNjYgMy41MzEzM0MxNC43MTQ1IDMuNDA0NjYgMTQuODMzMyAzLjE5MDkxIDE0LjgzMzMgMi45NjEzM0MxNC44MzMzIDIuNDMwOTEgMTQuMjU1MyAyLjExNDI1IDEzLjgwNDEgMi4zOTEzM0w4LjQ5OTkyIDUuNzA4NDFMMy4xOTU3NSAyLjM5MTMzQzIuNzQ0NSAyLjExNDI1IDIuMTY2NTkgMi40MzA5MSAyLjE2NjU5IDIuOTYxMzNDMi4xNjY1OSAzLjE5MDkxIDIuMjg1MzQgMy40MDQ2NiAyLjQ4MzI1IDMuNTMxMzNMNy42NjA3NSA2Ljc2OTI1QzguMTc1MzMgNy4wOTM4MyA4LjgyNDUgNy4wOTM4MyA5LjMzOTA5IDYuNzY5MjVaIiBmaWxsPSIjRUY3MTJCIi8+Cjwvc3ZnPgo="
                    />
                  </a>
                </Col>
                <Col span={8} onClick={() => closeNav()}>
                  <UISearch
                    data={props.props}
                    isMobile={props.props.isMobile}
                  />
                </Col>
                <Col span={24}>
                  <UiLanguage props={props.props} />
                </Col>
              </Row>
            </Space>
          </div>
          <div id="blakBackground" className={s.blankContent}></div>
        </div>
      ) : (
        <div className={s.root}>
          <div className={s.stickyWrapper}>
            <div className={s.container}>
              <Row justify="space-between">
                <Col span={24} style={{ padding: '0px 10px' }}>
                  <Row style={{ alignItems: 'center' }}>
                    <Col flex="auto">
                      <UiLanguage props={props.props} />
                    </Col>
                    <Col style={{ padding: '0px 20px 5px' }}>
                      <UISearch data={props.props} />
                    </Col>
                    <Col>
                      <ModalLogin
                        visible={visibleLogin}
                        handleLogin={isLogin => onClickLogin(isLogin)}
                        handleCancelLogin={() => cancelLogin()}
                        hiddenButton={false}
                        tokenUser={token}
                        language={props.props.language}
                        isMobile={props.props.isMobile}
                        userData={userData}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col span={5}>
                  <Row style={{ padding: '0px 10px' }}>
                    <Col style={{ paddingRight: '10px' }}>
                      <Link className={s.brand} to="/">
                        <img
                          src={
                            props.dataHeaderFooter.hfLogoPath
                              ? props.dataHeaderFooter.hfLogoPath
                              : logoUrl
                          }
                          alt="loyola"
                          style={{ width: 72, height: 72 }}
                        />
                      </Link>
                    </Col>
                    <Col
                      style={{
                        textAlign: 'left',
                        flex: 1,
                        alignSelf: 'center',
                      }}
                    >
                      <div>
                        <Link className={s.brand} to="/">
                          <span className={s.titleHeader} style={{whiteSpace: 'pre-line'}}>
                            {props.dataHeaderFooter.namaInstitusi ?  props.dataHeaderFooter.namaInstitusi.replace("\\n", '\n') : ''}
                          </span>
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col span={19} style={{ alignSelf: 'center' }}>
                  <Navigation
                    language={props.props.language}
                    addMenu={menuHeader}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

Header.propTypes = {
  dataHeaderFooter: PropTypes.node.isRequired,
  logoBidikti: PropTypes.object.isRequired,
  logoLoyola: PropTypes.object.isRequired,
};
